import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getUiInterface } from '../../locales/translationUtils';

interface ConfirmDeleteModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ show, onHide, onConfirm }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{getUiInterface("confirmDeletion")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{getUiInterface("confirmMessageDeletion")}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                {getUiInterface("no")}
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                {getUiInterface("yes")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDeleteModal;
